import getters from './getters';
import mutations from './mutations';
import actions from './actions';

export default {
  namespaced: true,
  state: {
    /** {Panorama} */
    data: {
      minimaps: [],
    },
    hotspot: undefined,
    viewYaw: undefined,
  },
  getters,
  mutations,
  actions,
};
